import { AsideDrawer } from '@single-platform/components';
import styled from 'styled-components';

export const StyledAside = styled(AsideDrawer)`
  &.open {
    overflow: hidden !important;
  }
`;
